module.exports = __webpack_public_path__ + "img/Menu-06.9b9737d4.webp";